"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _components = require("../../../components");

var _hooks = require("../../../hooks");

var _arrow = require("./arrow.svg");

var _ex = require("./ex.svg");

var _minus = require("./minus.svg");

var _plus = require("./plus.svg");

var _ModifierItemModule = _interopRequireDefault(require("./ModifierItem.module.scss"));

var _visuallyHidden = require("@react-aria/visually-hidden");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ModiifierItem = function ModiifierItem(_ref) {
  var cellType = _ref.cellType,
      name = _ref.name,
      price = _ref.price,
      isNested = _ref.isNested,
      quantity = _ref.quantity,
      multiSelect = _ref.multiSelect,
      onClick = _ref.onClick,
      increment = _ref.increment,
      decrement = _ref.decrement,
      imgSrc = _ref.imgSrc,
      description = _ref.description;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views;

  var incrementClass = (0, _classnames["default"])(_ModifierItemModule["default"].increment, _ModifierItemModule["default"]["modifierItem-col"], quantity && multiSelect ? _ModifierItemModule["default"]["modifierItem-col--active"] : _ModifierItemModule["default"]["modifierItem-col--inactive"]);
  var decrementClass = (0, _classnames["default"])(_ModifierItemModule["default"].decrement, _ModifierItemModule["default"]["modifierItem-col"], _ModifierItemModule["default"]["modifierItem-col--".concat(quantity ? "active" : "inactive")]);
  return /*#__PURE__*/_react["default"].createElement(_components.Box, {
    grid: {
      xs: "1-2",
      sm: "1-3",
      md: "1-3"
    },
    className: _ModifierItemModule["default"].modifierItem
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    className: _ModifierItemModule["default"]["modifierItem-wrapper"],
    onClick: !multiSelect || multiSelect && !quantity ? onClick : null,
    dataTest: name,
    style: {
      backgroundImage: "url(".concat(imgSrc, ")")
    },
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_ModifierItemModule["default"]["modifierItem-content"], " ").concat(_ModifierItemModule["default"]["modifierItem-content--".concat(quantity ? "active" : "inactive")])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: description ? _ModifierItemModule["default"]["modifierItem-content--name"] : ""
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary
  }, name), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: isNested
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-nestedSelector"]
  }, /*#__PURE__*/_react["default"].createElement(_arrow.ReactComponent, {
    fill: "#fff"
  }))))), description && /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-content--desc"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, description)), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: price
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-content--price"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, price))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !isNested
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-action"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: decrementClass
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    className: _ModifierItemModule["default"]["modifierItem-btn"],
    type: buttons.primary,
    onClick: multiSelect ? decrement : onClick
  }, multiSelect ? /*#__PURE__*/_react["default"].createElement(_minus.ReactComponent, {
    fill: "#fff"
  }) : /*#__PURE__*/_react["default"].createElement(_ex.ReactComponent, {
    fill: "#fff"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: incrementClass
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    className: _ModifierItemModule["default"]["modifierItem-btn"],
    type: buttons.primary,
    onClick: increment
  }, /*#__PURE__*/_react["default"].createElement(_plus.ReactComponent, {
    fill: "#fff"
  }))), quantity > 0 && multiSelect && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_ModifierItemModule["default"].qty, " ").concat(_ModifierItemModule["default"]["modifierItem-col"], " ").concat(_ModifierItemModule["default"]["modifierItem-col--active"])
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    "aria-live": "polite",
    type: labelTextStyles.tertiary
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, name, " Quantity: "), quantity))))));
};

var _default = /*#__PURE__*/_react["default"].memo(ModiifierItem);

exports["default"] = _default;